// admin - is the super admin
// account - an account owner and admin
// user - an account user, maybe an account admin
// reseller - just a reseller, may have an account
// broker - doesn't have an account.
export const ROLE_SUPER_ADMIN = "super-admin";
export const ROLE_ADMIN = "admin" as const;
export const ROLE_USER = "user" as const;

export type Role =
  | typeof ROLE_SUPER_ADMIN
  | typeof ROLE_ADMIN
  | typeof ROLE_USER;

export const ROLE_RANK: Record<Role, number> = {
  [ROLE_USER]: 3,
  [ROLE_ADMIN]: 4,
  [ROLE_SUPER_ADMIN]: 5,
};

/**
 * Get the rank of a role.
 * @param role - The role to get the rank for.
 * Ignores negative roles
 */
export const getRoleRank = (role: Role): number => {
  const rank = ROLE_RANK[role] ?? 0;
  return rank < 0 ? 0 : rank;
};

/**
 * Check if a role has at least the privileges of another role.
 * @param role - The role to check.
 * @param atLeast - The role to compare against.
 */
export const isRoleAtLeast = (role: Role, atLeast: Role): boolean =>
  getRoleRank(role) >= getRoleRank(atLeast);

export const isSuperAdmin = (role: Role) => role === ROLE_SUPER_ADMIN;

export const getAvailableRoles = (currentUserRole: Role): Role[] => {
  const currentRank = ROLE_RANK[currentUserRole];

  return (Object.entries(ROLE_RANK) as [Role, number][])
    .filter(([, rank]) => rank >= 0)
    .filter(([, rank]) => rank <= currentRank)
    .map(([role]) => role);
};
